module.exports = __webpack_public_path__ + "static/media/image (25).b78a723d.jpg";